import type { CalendarEventDto } from '../../api/calendar';

/**
 * isEventAssignedToMe — "이 일정이 나와 관련있나(배정됨)" 판정.
 *
 * 작성자거나, 명시 참석자(attendees)에 있거나, 팀 캘린더 일정이라 attendees 행 대신
 * teamMembers(팀 구성원 전체)로 참여자를 나타내는 경우도 포함한다. myUserId 가
 * 없으면(비로그인/판정 불가) 항상 배정된 것으로 본다 — 화면 렌더 쪽의 기존 관례를
 * 그대로 따른 것("채움 vs 테두리만" 판정이라 판정 불가면 채움이 안전하다).
 *
 * ⚠ **`lib/eventOwnership.ts` 의 `isMineEvent` 와 다른 것이다.** 그쪽은 「내가 «만든» 것인가」
 *   (작성자만)이고 이쪽은 「내가 «관련된» 것인가」(작성자 + 참석자 + 팀원)다. 목적이 달라서
 *   합치지 않는다 — 합치면 어느 한쪽이 반드시 회귀한다.
 *
 * ⚠ `teamMembers` 는 서버가 아직 안 보낸다(api/calendar.ts 의 그 칸 주석 참조). 그동안은
 *   `?? false` 로 떨어져 「작성자 + 참석자」로만 판정한다 — 그 칸이 오면 저절로 정확해진다.
 */
export function isEventAssignedToMe(e: CalendarEventDto, myUserId: string | null | undefined): boolean {
  return myUserId == null
    || e.creatorId === myUserId
    || e.attendees.some((a) => a.userId === myUserId)
    || (e.teamMembers?.some((m) => m.userId === myUserId) ?? false);
}
